function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NicaraguaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2224",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2224)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2224",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2224)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V9H24V3H0Z",
        fill: "#0080EC"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#0080EC"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 9C12.1413 9 12.2804 9.00977 12.4165 9.02868L12.268 9.98572C12.1803 9.97417 12.0908 9.96821 12 9.96821C11.8679 9.96821 11.7387 9.98082 11.6137 10.0049L11.5442 9.0344C11.6929 9.01175 11.8451 9 12 9ZM12.8641 9.12631L12.6034 10.0593C13.4309 10.3163 14.0318 11.088 14.0318 12C14.0318 12.0224 14.0315 12.0448 14.0307 12.067L14.9964 12.1489C14.9988 12.0995 15 12.0499 15 12C15 10.6435 14.0997 9.49733 12.8641 9.12631ZM14.6351 13.4352C14.1597 14.3062 13.265 14.9155 12.2222 14.9919V14.0198C12.7777 13.9594 13.266 13.6751 13.5949 13.2589L14.6351 13.4352ZM9.43261 13.5528C9.93059 14.3744 10.8118 14.9378 11.8284 14.9952V14.0247C11.2359 13.9751 10.7157 13.6714 10.3772 13.2228L9.43261 13.5528ZM9.00271 12.1287C9.00091 12.086 9 12.0431 9 12C9 10.7262 9.79392 9.63777 10.9139 9.20262L11.1643 10.1475C10.4632 10.4643 9.97395 11.1674 9.96824 11.9855L9.00271 12.1287Z",
        fill: "#D0AB00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9811 9.7123L9.92847 13.2604H14.066L11.9811 9.7123Z",
        fill: "#7CDFFF"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_2224",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "9",
        y: "9",
        width: "6",
        height: "5",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9811 9.7123L9.92847 13.2604H14.066L11.9811 9.7123Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_2224)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M12 14.2137C12.9213 14.2137 13.6682 13.4668 13.6682 12.5455C13.6682 11.6242 12.9213 10.8773 12 10.8773C11.0787 10.8773 10.3318 11.6242 10.3318 12.5455C10.3318 13.4668 11.0787 14.2137 12 14.2137Z",
          stroke: "#E31D1C",
          strokeWidth: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          d: "M12 14.2137C12.9213 14.2137 13.6682 13.4668 13.6682 12.5455C13.6682 11.6242 12.9213 10.8773 12 10.8773C11.0787 10.8773 10.3318 11.6242 10.3318 12.5455C10.3318 13.4668 11.0787 14.2137 12 14.2137Z",
          stroke: "#FFD018",
          strokeWidth: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          d: "M12 14.2137C12.9213 14.2137 13.6682 13.4668 13.6682 12.5455C13.6682 11.6242 12.9213 10.8773 12 10.8773C11.0787 10.8773 10.3318 11.6242 10.3318 12.5455C10.3318 13.4668 11.0787 14.2137 12 14.2137Z",
          stroke: "#4EDD00",
          strokeWidth: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          d: "M12 14.2137C12.9213 14.2137 13.6682 13.4668 13.6682 12.5455C13.6682 11.6242 12.9213 10.8773 12 10.8773C11.0787 10.8773 10.3318 11.6242 10.3318 12.5455C10.3318 13.4668 11.0787 14.2137 12 14.2137Z",
          stroke: "#3D58DB",
          strokeWidth: "0.5"
        }), /*#__PURE__*/_jsx("rect", {
          x: "9.76364",
          y: "12.1637",
          width: "4.69091",
          height: "1.36364",
          fill: "#3D58DB"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.0777 12.7432L11.0126 11.8135L11.2996 12.2783L11.5 11.7114L11.7226 12.1364L11.9565 11.8135L12.259 12.1364L12.5364 11.7114L12.7735 12.1364L13.0455 11.8135L13.6812 12.489L13.7956 12.7432L10.0777 12.9318V12.7432Z",
          fill: "#97C923"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=Nicaragua.js.map